import React from 'react';
import styled from 'styled-components';

const Title = styled.h2`
    color: #009d80;
    text-align: center;
    margin-bottom: 20px;
`;

const TrColor = styled.tr`
    color: #00ad80;
`;
const TdColor = styled.td`
    color: #00ad80;
`;
const Table = () => {
    return (
        <>
            <Title>令和８年度　公立高校入試A日程での競争倍率</Title>
            <table className="table table-border text-center">
                <thead>
                    <tr><th>学校名</th><th>競争倍率</th><th>不合格者数</th></tr>
                </thead>
                <tbody>
                    <tr>
                        <TdColor>高知商業（社会マネ）</TdColor><TdColor>1.29倍</TdColor><TdColor>20名</TdColor>
                    </tr>
                    <tr>
                        <TdColor>高知農業（生総）</TdColor><TdColor>1.28倍</TdColor><td>11名</td>
                    </tr>
                    <tr>
                        <TdColor>高知農業（畜総）</TdColor><TdColor>1.28倍</TdColor><td>11名</td>
                    </tr>
                    <tr>
                        <td>丸の内（普通）</td><td>1.17倍</td><TdColor>24名</TdColor>
                    </tr>
                    <tr>
                        <td>高知商業（情報マネ）</td><td>1.17倍</td><td>6名</td>
                    </tr>
                    <tr>
                        <td>高知工業（建築）</td><td>1.15倍</td><td>6名</td>
                    </tr>
                </tbody>
            </table>

        </>
    );
}

export default Table;